<div fxFill fxLayout="column">
    <div fxFlex fxFill fxLayout id="companion-data-tree-container">
        <div id="companion-data-tree">
        </div>
    </div>
</div>